<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" v-if="pushLink"/>
    <div class="save-panel">
      <svg class="svg-angle svg-angle-1" width="30" height="30" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><path d="M0 29V0C0 16.0163 12.9837 29 29 29H0Z"/></svg>
      <svg class="svg-angle svg-angle-2" width="30" height="30" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><path d="M0 29V0C0 16.0163 12.9837 29 29 29H0Z"/></svg>
      <button class="btn btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{ "save" | setText("Сохранить") }}
      </button>
    </div>
  </div>
</template>
<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data(){
    return {
      cardLink: "lessonplans",
      cardSetLink: "lessonplans",
      item: null,
      pushLink: "",
      fields: [
        {
          col: "col-12 col-md-4",
          key: "position",
          label: "Номер темы",
          type: "field",
          textType: "number",
        },
        {
          col: "col-12 col-md-8",
          key: "name",
          label: "Название темы",
          type: "field",
          textType: "text",
        },
        {
          col: "col-12 col-md-8",
          key: "homework",
          label: "Домашнее задание",
          type: "field",
          textType: "text",
        },
        {
          label: "Учебник",
          pushLink: `${this.$store.state.secApiUrl}/school/subjects/${this.$route.query["item_discipline"]}/classes/${this.$route.query["item_books"]}/books`,
          key: "classbook",
          type: "select",
          selectKey: "file_name",
          modal: "books",
          params: {}
        },
        {
          col: "col-12 col-md-4",
          key: "classbook_page",
          value: 1,
          label: "Номер страницы",
          type: "field",
          textType: "number",
        },
        // {
        //   label: "Предмет",
        //   key: "discipline",
        //   type: "select",
        //   selectKey: "title",
        //   modal: "discipline",
        //   prefix: "lessonplan_discipline",
        // },
        // {
        //   col: "col-12 col-md-6",
        //   key: "locale",
        //   label: "Локализация контента",
        //   type: "locale",
        //   textType: "text",
        // },
        // {
        //   col: "col-12 col-md-6",
        //   label: "Для классов",
        //   key: "course_id",
        //   type: "course",
        //   selectKey: "title",
        // },
      ],
    }
  },
  props: ["id"],
  async created() {
    let query = Object.assign({}, this.$route.query);
    this.pushLink = `${this.$store.state.secApiUrl}/school/subjects/${query["item_discipline"]}/classes/${query["item_books"]}/books`
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
  
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );
    },
  },
};
</script>
<style>
</style>
